/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syllable Counter — Count Syllables in Text | Toolverse`)
};

const es_syl_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de sílabas — Cuenta sílabas en un texto | Toolverse`)
};

const de_syl_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silbenzähler — Silben in Texten zählen | Toolverse`)
};

const nl_syl_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettergreepteller — Tel Lettergrepen in Tekst | Toolverse`)
};

const fr_syl_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de syllabes — Comptez les syllabes d'un texte | Toolverse`)
};

const it_syl_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di Sillabe — Conta le Sillabe nel Testo | Toolverse`)
};

const pt_br2_syl_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Sílabas — Conte Sílabas no Texto | Toolverse`)
};

const pt_syl_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Sílabas — Conte Sílabas no Texto | Toolverse`)
};

const ja_syl_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音節カウンター — テキストの音節数をカウント | Toolverse`)
};

const zh_syl_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音节计数器 — 统计文本音节数 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_hub_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_hub_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_hub_meta_title", locale)
	if (locale === "en") return en_syl_hub_meta_title(inputs)
	if (locale === "es") return es_syl_hub_meta_title(inputs)
	if (locale === "de") return de_syl_hub_meta_title(inputs)
	if (locale === "nl") return nl_syl_hub_meta_title(inputs)
	if (locale === "fr") return fr_syl_hub_meta_title(inputs)
	if (locale === "it") return it_syl_hub_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_syl_hub_meta_title(inputs)
	if (locale === "pt") return pt_syl_hub_meta_title(inputs)
	if (locale === "ja") return ja_syl_hub_meta_title(inputs)
	return zh_syl_hub_meta_title(inputs)
};